import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { LivetvlistdetailsDTO } from "./dto/livetvlist.dto";


export class livetvlisttvResponseModel extends GlobalResponseObject {
    data?: LivetvlistdetailsDTO[];
    //response: LivetvlistdetailsDTO[];
}
export class livetvliststatusResponseModel extends GlobalResponseObject {
    data?:LivetvlistdetailsDTO;
}